import React from 'react'
import css from './Hero.module.css'
import HeroImg from '../../assets/hero.png'
import { RiShoppingBagFill } from 'react-icons/ri'
import { BsArrowRight } from 'react-icons/bs'
import { motion } from 'framer-motion'


const Hero = () => {
    const transition = { duration: 3, type: "spring" }

    return (
        <div className={css.container}>
            <div className={css.h_sides}>
                <div className={css.text1}><span>skin protection cream</span></div>

                <div className={css.text2}>
                    <span>Trendy Collection</span>
                    <span>
                        {" "}
                        Enjoy huge discounts on your favorite items.
                        Limited time offer
                        Browse our collection and find the
                        perfect products for you.
                    </span>
                </div>
            </div>

            <div className={css.wrapper}>
                {/* Brown Circle */}
                <motion.div
                    initial={{ bottom: "1.5rem" }}
                    whileInView={{ bottom: "0rem" }}
                    className={css.brownCircle}
                    transition={transition}
                    ></motion.div>

                {/* Hero Image */}
                <motion.img 
                transition={transition}
                initial={{bottom: "-2rem"}}
                whileInView={{bottom: "0rem"}}
                src={HeroImg} alt="" width={600} />
                
                <motion.div
                transition={transition}
                initial={{right: "4%"}}
                whileInView={{right: "2%"}}
                className={css.cart2}>
                    <RiShoppingBagFill />

                    <div className={css.signup}>
                        <span>Best Signup Offers</span>

                        <div>
                            <BsArrowRight />
                        </div>
                    </div>
                </motion.div>

            </div>

            <div className={css.h_sides}>
                <div className={css.traffic}>
                    <span>1.5m</span>
                    <span>Monthly Traffic</span>
                </div>

                <div className={css.customers}>
                    <span>100k</span>
                    <span>Satisfied Customers</span>
                </div>
            </div>
        </div>

    )
}

export default Hero;
